module.exports = __webpack_public_path__ + "static/zjcmobile-d8b34c5287f7efc3a855b31c83dad320.png";